module.exports = __webpack_public_path__ + "static/media/informatyka.5e9d7466.svg";